import type { IncomingMessage } from "http";
import Appsignal from "@appsignal/javascript";

// https://docs.appsignal.com/front-end/configuration
export const appsignal = new Appsignal({
  key: process.env.NEXT_PUBLIC_APPSIGNAL_FRONTEND_KEY,
  revision: process.env.NEXT_PUBLIC_GIT_COMMIT_SHA || "default_revision",
  namespace: `nitoelFrontend-${process.env.NEXT_PUBLIC_KIND || "local"}`,
});

// 誰の操作か、を取得するための関数
export const fetchMe = async (token: string | undefined) => {
  if (!token) return;

  const baseUrl = `${process.env.NEXT_PUBLIC_BACKEND_API_BASE_URL}/private_api/supplier`;
  return await fetch(baseUrl + "/me", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => response.json())
    .catch(() => null);
};

export const xReferer = (req: IncomingMessage): string => {
  return (req.headers["x-nitoel-referer"] as string) || (req.headers["referer"] as string) || "";
};

type MeType = {
  id: string | number;
  name: string;
  email: string;
  supplierCorporationId?: string | number | null;
  supplierAccountEmployeeLinkId?: string | number | null;
  supplierCorporation?: { id: string | number } | null;
};

export const appsignalTags = (me: MeType | undefined | null, referer: string): { [key: string]: string } => {
  if (me) {
    const corporationId = me.supplierCorporationId ?? me.supplierCorporation?.id;
    const employeeLinkId = me.supplierAccountEmployeeLinkId;
    // NOTE: nameだけが何故かどうやっても渡すことができず(入れると通知が飛ばなくなる。keyをhogeとかに変えてもだめだった)一旦コメントアウトしておく。
    // let { email, name } = me;
    // name = name.split(" ")[0] + " XXX";
    // - https://docs.appsignal.com/guides/custom-data/tagging-request.html
    // あまり個人情報を送り込んでほしくないらしく、まぁ確かに全部渡す必要もないと思うので何となく分かる程度にマスクする。
    let { email } = me;
    email = "XXX@" + email?.split("@")[1];
    return {
      supplierAccountId: String(me.id),
      ...(corporationId != null ? { supplierCorporationId: String(corporationId) } : {}),
      ...(employeeLinkId != null ? { supplierAccountEmployeeLinkId: String(employeeLinkId) } : {}),
      email,
      referer,
    };
  } else {
    return { referer };
  }
};

// Front Door WAF ブロック判定
// 判別軸は content-type ＋ 本文マーカ。x-azure-ref / x-cache は正常応答にも付くため使わない。
// NOTE: 「WAFブロック＝403 かつ 非JSON かつ 本文マーカ」は infra/waf.tf でカスタムブロック応答未設定が前提。
export const detectFrontDoorWafBlock = (status: number, headers: Headers, body: string): boolean => {
  if (status !== 403) return false;
  const contentType = (headers.get("content-type") || "").toLowerCase();
  if (contentType.includes("application/json")) return false; // バックエンドの認可403(JSON)は除外
  return body.includes("The request is blocked"); // AFD ブロックページの確定マーカ
};

export const reportToAppsignal = (err: Error, me: MeType | undefined | null, referer: string) => {
  appsignal.sendError(err, (span) => {
    const a = appsignalTags(me, referer);
    span.setTags(a);
  });
};
